<template>
	<div class="mine">
		<div class="page-content">
			<div class="top">
				<div class="setting">
					<!-- 客服图标移到右侧 -->
					<div class="service-icon" @click="toService">
						<van-icon name="chat-o" size="1.8rem" color="#fff" />
					</div>
				</div>
				<div class="avatar">
					<div class="avatar-upload" @click="chooseAvatar">
					<van-image round width="4.2rem" height="4.2rem" :src="smallLogo">
						<template v-slot:loading>
							<van-loading type="spinner"/>
						</template>
					</van-image>
					<span class="avatar-edit"><van-icon name="photograph" /></span>
					<input ref="avatarInput" class="avatar-file" type="file" accept="image/jpeg,image/png,image/webp" @change="uploadAvatar">
					</div>
					<div class="me">
						<div class="user" style="flex-direction: initial; align-items: center;">
							<p style="padding-bottom: 0px;">{{userInfo.username}}</p>
							<span style="margin-left: 10px;" v-if="userInfo.is_vip==1">
								<img :src="'img/vip'+userInfo.vip_level+'.png'" alt="" style="width: 90px;">
							</span>
						</div>
						<div class="ps">
							<span style="padding-left: 0px; margin: 4px 0px 2px;">{{$t('mine.xyfs')}}: {{userInfo.credit || 0}}</span>
						</div>
						<div class="ps">
							<span class="vip-level-badge">{{$t('vipLevelLabel')}} {{vipLevel}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="center">
				<div class="integral">
					<div @click="doPay()">
						<i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 26px;">
							<img class="van-icon__image" src="/img/qianbao.png">
						</i>
						<span>{{$t('mine.recharge')}}</span>
					</div>
					<div @click="doWithdrawal()">
						<i class="van-badge__wrapper van-icon" style="color: rgb(0, 0, 0); font-size: 26px;">
							<img class="van-icon__image" src="/img/piao.png">
						</i>
						<span>{{$t('mine.withdraw')}}</span>
					</div>
				</div>
				<div class="mineJf animate__animated animate__flipInX">
					<div class="title">
						<p>{{$t('mine.money')}}</p>
					</div>
					<div class="reload">
						<h1>{{displayMoney}}</h1>
						<div @click="onRefresh()">
							<span>(Points)</span>
							<van-icon name="/img/reload.png" size="1.2rem" color="#fff" />
						</div>
					</div>
				</div>
				<div class="list animate__animated animate__fadeIn">
<!-- 					<div @click="showSetting()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/zhangdan.png"></i><span>{{$t('mine.infomation')}}</span></div> -->
					<div @click="$router.push({path:'/MoneyLog'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/shujuku.png"></i><span>{{$t('mine.moneylog')}}</span></div>
					<div @click="$router.push({path:'/WithdrawRecord'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/zhangdan2.png"></i><span>{{$t('mine.withdrawrecord')}}</span></div>
					<div @click="$router.push({path:'/GameRecord'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/youxi.png"></i><span>{{$t('mine.gamerecord')}}</span></div>
					<div @click="toPayPassword()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/anquan.png"></i><span>{{$t('mine.paypwd')}}</span></div>
					<div @click="$router.push({path:'/Mymove'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/dianying.png"></i><span>{{$t('mine.mymove')}}</span></div>
					<div @click="toLoginPassword()"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/suo.png"></i><span>{{$t('mine.loginpwd')}}</span></div>
					<div @click="$router.push({path:'/Setbank'});"><i class="van-badge__wrapper van-icon" style="color: rgb(134, 134, 134); font-size: 26px;"><img class="van-icon__image" src="/img/qianbao.png"></i><span>{{$t('common.setbank')}}</span></div>
				</div>
				<a class="btns" @click="loginout()">{{$t('mine.loginout')}}</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    const cachedUser = this.$store.getters.getUserInfo || {};
    const cachedMoney = cachedUser.money;
    const hasCachedMoney = cachedMoney !== '' && cachedMoney !== null && cachedMoney !== undefined && Number.isFinite(Number(cachedMoney));
    const balanceIdentity = cachedUser.id || cachedUser.username || 'current';
    let balanceCache = null;
    try {
      balanceCache = JSON.parse(localStorage.getItem(`lastKnownBalance:${balanceIdentity}`) || 'null');
    } catch (error) {
      balanceCache = null;
    }
    const cacheValue = balanceCache && balanceCache.value;
    const hasBalanceCache = cacheValue !== '' && cacheValue !== null && cacheValue !== undefined && Number.isFinite(Number(cacheValue));
    return {
      userInfo: { ...cachedUser },
      lastKnownMoney: hasCachedMoney ? cachedMoney : (hasBalanceCache ? cacheValue : 0),
      balanceUpdatedAt: balanceCache && balanceCache.updatedAt ? Number(balanceCache.updatedAt) : 0,
      balanceRefreshing: false,
      userInfoRequestId: 0,
      defaultAvatar: '/img/logo2a.png',
      avatarUploading: false,
      menu_top: 40,
      isLoading: false,
      // 累计积分相关数据
      currentPoints: 0,
      targetPoints: 1000,
      progressWidth: 0
    };
  },
  computed: {
    smallLogo() {
      const baseInfo = this.$store.getters.getBaseInfo || {};
      return baseInfo.ico || baseInfo.logo || this.userInfo.header_img || this.defaultAvatar;
    },
    displayMoney() {
      const currentMoney = this.userInfo.money;
      const hasCurrentMoney = currentMoney !== '' && currentMoney !== null && currentMoney !== undefined && Number.isFinite(Number(currentMoney));
      const money = Number(hasCurrentMoney ? currentMoney : this.lastKnownMoney);
      return Number.isFinite(money) ? money.toFixed(2) : '0.00';
    },
    vipLevel() {
      const level = this.userInfo.vip_level ?? this.userInfo.vip ?? this.userInfo.level ?? 0;
      return Number.isFinite(Number(level)) ? Number(level) : 0;
    }
  },
  methods: {
    isValidMoney(value) {
      return value !== '' && value !== null && value !== undefined && Number.isFinite(Number(value));
    },
    getBalanceCacheKey(user = this.userInfo) {
      const identity = user && (user.id || user.username) ? (user.id || user.username) : 'current';
      return `lastKnownBalance:${identity}`;
    },
    saveValidBalance(value, user = this.userInfo) {
      if (!this.isValidMoney(value)) return false;
      this.lastKnownMoney = value;
      this.balanceUpdatedAt = Date.now();
      localStorage.setItem(this.getBalanceCacheKey(user), JSON.stringify({
        value,
        updatedAt: this.balanceUpdatedAt
      }));
      return true;
    },
    chooseAvatar() {
      if (!localStorage.getItem('token') || this.avatarUploading) return;
      this.$refs.avatarInput && this.$refs.avatarInput.click();
    },
    uploadAvatar(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        this.$toast(this.$t('common.imageTooLarge'));
        input.value = '';
        return;
      }
      const form = new FormData();
      form.append('file', file);
      this.avatarUploading = true;
      this.$toast.loading({ message: this.$t('common.uploading'), forbidClick: true, duration: 0 });
      this.$http({ method: 'post', data: form, url: 'user_header_img' }).then(res => {
        this.$toast.clear();
        this.avatarUploading = false;
        input.value = '';
        if (res.code === 200) {
          this.$toast.success(res.msg || 'Upload successful');
          this.getUserInfo();
        } else {
          this.$toast(res.msg || this.$t('common.uploadFailed'));
        }
      }).catch(() => {
        this.$toast.clear();
        this.avatarUploading = false;
        input.value = '';
        this.$toast(this.$t('common.uploadFailed'));
      });
    },
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t('common.refresh'));
        } else {
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t('common.noallow'));
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Infomation'})
      } else {
        this.$router.push({path:'/Login'})
      }
    },
    toPayPassword() {
      this.$router.push({path:'/SetPayPassword'});
    },
    toLoginPassword() {
      this.$router.push({path:'/SetLoginPassword'});
    },
    loginout() {
      localStorage.clear()
      this.$router.push({path:'/Login'});
    },
    toNotice() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      } else {
        this.$router.push({path:'/Login'})
      }
    },
    async onRefresh() {
      if (!localStorage.getItem('token')) {
        this.$router.push({path:'/Login'});
        return;
      }
      if (this.balanceRefreshing) return;
      this.isLoading = true;
      try {
        await this.getUserInfo();
        this.$toast(this.$t('common.refresh'));
      } finally {
        this.isLoading = false;
      }
    },
    doLogin() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Infomation'});
      } else {
        this.$router.push({path:'/Login'})
      }
    },
    doPay() {
      this.$router.push("recharge");
      return false;
    },
    doWithdrawal() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
        return;
      }
      this.$router.push({ path: '/Withdraw' });
    },
    toService() {
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t('common.noallow'));
      }
    },
    getUserInfo() {
      const mockUser = this.$store.getters.getUserInfo;
      if (process.env.NODE_ENV === 'development' && mockUser && mockUser.isMock) {
        this.userInfo = { ...mockUser };
        this.menu_top = 15;
        this.updatePointsProgress();
        return Promise.resolve(mockUser);
      }
      const requestId = ++this.userInfoRequestId;
      this.balanceRefreshing = true;
      return this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (requestId !== this.userInfoRequestId) return;
        if(res.code === 200 || res.code === 0){
          const apiUser = res.data && typeof res.data === 'object' ? res.data : {};
          const storedUser = this.$store.getters.getUserInfo || {};
          const previousUser = { ...storedUser, ...this.userInfo };
          const apiMoney = apiUser.money;
          const hasApiMoney = this.isValidMoney(apiMoney);
          const previousMoney = previousUser.money;
          const hasPreviousMoney = this.isValidMoney(previousMoney);
          const safeMoney = hasApiMoney ? apiMoney : (hasPreviousMoney ? previousMoney : this.lastKnownMoney);
          if (hasApiMoney) this.saveValidBalance(apiMoney, { ...previousUser, ...apiUser });
          this.userInfo = {
            ...previousUser,
            ...apiUser,
            header_img: apiUser.header_img || previousUser.header_img || this.defaultAvatar,
            money: safeMoney,
            credit: apiUser.credit == null ? (previousUser.credit || 0) : apiUser.credit
          };
          this.$store.commit('updateUserInfo', this.userInfo);
          this.menu_top = 15;
          
          // 更新积分进度
          this.updatePointsProgress();
          
          if(Number(this.userInfo.status) !== 1){
            this.$toast(this.$t('accountOffline'));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
        return this.userInfo;
      }).catch(() => {
        // 网络或接口异常时保留最后一次有效余额，避免界面闪成空白或 0。
        return this.userInfo;
      }).finally(() => {
        if (requestId === this.userInfoRequestId) this.balanceRefreshing = false;
      })
    },
    // 更新积分进度
    updatePointsProgress() {
      // 模拟积分数据，实际应从API获取
      this.currentPoints = Number(this.userInfo.credit || this.userInfo.xyjf || 0);
      this.targetPoints = 1000;
      
      // 计算进度百分比
      this.progressWidth = Math.min((this.currentPoints / this.targetPoints) * 100, 100);
    }
  },
  created() {
    if(localStorage.getItem('token')){
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t('mine.lorr');
      this.userInfo.ip = this.$t('loginForMore');
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  },
  mounted() {
    // 初始化积分进度动画
    setTimeout(() => {
      this.updatePointsProgress();
    }, 300);
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";

:export {
  gbcolor: linear-gradient(30deg, #3498db, #8e44ad)
}

/* 主容器 */
.mine {
  width: 100%;
  min-height: 100vh;
  background: #f2f2f5;
  position: relative;
}

/* 页面内容区域 - 关键修复 */
.page-content {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  z-index: 1; /* 页面内容在底层 */
  padding-bottom: 60px; /* 为底部导航预留空间 */
  box-sizing: border-box;
}

.mine .van-share-sheet__description span {
  background: linear-gradient(30deg, #3498db, #8e44ad);
  padding: 10px 20px;
  font-size: 14px;
  display: inline-block;
  border-radius: 4px;
  color: #fff;
  margin: 4px 0;
}

.mine .top {
  width: 100%;
  height: 13.33333rem;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  position: relative;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
}

.mine .top::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  background: #f2f2f5;
  border-radius: 20px 20px 0 0;
}

.mine .top .setting {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 1rem;
  position: relative;
  z-index: 1;
}

.mine .top .setting .service-icon {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.mine .top .setting .service-icon:hover {
  transform: scale(1.1);
}

.mine .top .avatar {
  width: 100%;
  padding: 0 6%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1.33333rem;
  position: relative;
  z-index: 1;
}

.mine .top .avatar .van-image {
  border: 4px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.avatar-upload { position: relative; flex: 0 0 auto; cursor: pointer; }
.avatar-file { display: none; }
.avatar-edit { position: absolute; right: -2px; bottom: -2px; width: 1.45rem; height: 1.45rem; display: grid; place-items: center; border: 1px solid #f0d38d; border-radius: 50%; color: #171006; background: linear-gradient(135deg,#a97732,#efd38c); box-shadow: 0 4px 12px rgba(0,0,0,.38); }

.mine .top .avatar .me {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 1.33333rem;
  flex: 1;
}

.mine .top .avatar .me .user {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.mine .top .avatar .me .user p {
  font-size: 1rem;
  color: #fff;
  padding-bottom: .33333rem;
  font-weight: 500;
  margin: 0;
}

.mine .top .avatar .me .user img {
  width: 4.66667rem;
  margin: 0 0;
}

.mine .top .avatar .me .ps {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 4px 0;
}

.mine .top .avatar .me .ps>span {
  padding-left: .33333rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: .73333rem;
}

/* 累计积分进度条样式 */
.mine .top .avatar .me .progress-container {
  width: 40%;
  height: 6px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  overflow: hidden;
  margin: 8px 0;
  position: relative;
}

.mine .top .avatar .me .progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #ffd700, #ffec8b);
  border-radius: 3px;
  transition: width 1s ease-in-out;
  position: relative;
  overflow: hidden;
}

.mine .top .avatar .me .progress-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.mine .center {
  width: 94%;
  margin: -3rem auto 0;
  position: relative;
  z-index: 2;
}

.mine .center .integral {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
}

.mine .center .integral:before {
  content: "";
  position: absolute;
  width: 1px;
  height: 1.33333rem;
  border-radius: .66667rem;
  background: #f2f2f5;
}

.mine .center .integral>div {
  width: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  padding: 0.5rem;
}

.mine .center .integral>div:hover {
  transform: translateY(-2px);
}

.mine .center .integral>div span {
  margin-left: .66667rem;
  color: #432989;
  font-weight: 600;
}

.mine .center .mineJf {
  width: 100%;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1.2rem 0;
  margin-top: 1rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.mine .center .mineJf .title {
  display: flex;
  padding: 0 0 .66667rem;
  width: 90%;
  margin: 0 auto;
  justify-content: flex-start;
  align-items: center;
}

.mine .center .mineJf .title p {
  color: #fff;
  font-size: .93333rem;
  font-weight: 600;
  margin: 0;
}

.mine .center .mineJf .reload {
  width: 90%;
  margin: 0 auto;
  display: flex;
  padding-top: .33333rem;
  justify-content: space-between;
  align-items: center;
}

.mine .center .mineJf .reload h1 {
  color: #fff;
  font-size: 1.6rem;
  margin: 0;
  font-weight: bold;
}

.mine .center .mineJf .reload>div {
  color: #fff;
  font-size: .86667rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.mine .center .mineJf .reload>div:hover {
  transform: scale(1.05);
}

.mine .center .mineJf .reload>div span {
  padding-right: .66667rem;
}

.mine .center .mineJf .reload>div i {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: .33333rem;
  transition: all 0.3s;
}

.mine .center .btns {
  display: block;
  width: 100%;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  color: #fff;
  padding: 1rem 0;
  border-radius: 12px;
  font-size: .93333rem;
  cursor: pointer;
  margin: 1.66667rem auto 1rem;
  text-align: center;
  border: none;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  font-weight: 600;
}

.mine .center .btns:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.mine .center .list {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 1.2rem 0;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
}

.mine .center .list>div {
  width: 33.3333%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 8px;
}

.mine .center .list>div:hover {
  transform: translateY(-2px);
  background: rgba(102, 126, 234, 0.05);
}

.mine .center .list>div span {
  color: #432788;
  padding: .53333rem 0;
  font-size: 0.85rem;
  font-weight: 500;
}

.mine .center .list>div>i {
  margin-bottom: 0.5rem;
}

/* 适配全面屏 */
@media screen and (max-width: 750px) {
  .page-content {
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
  }
}

/* 账户中心：黑金轻奢主题 */
.mine {
  color: #f3eadb;
  background:
    linear-gradient(rgba(3, 5, 8, 0.8), rgba(3, 5, 8, 0.96)),
    url('../../assets/img/luxury-dating-bg-v2.png') center top / cover fixed no-repeat;
}

.mine .top {
  height: 14rem;
  border-bottom: 1px solid rgba(218, 180, 105, 0.42);
  border-radius: 0 0 30px 30px;
  background:
    radial-gradient(circle at 76% 12%, rgba(220, 178, 94, 0.18), transparent 32%),
    linear-gradient(145deg, rgba(5, 8, 12, 0.98), rgba(23, 18, 11, 0.96));
  box-shadow: 0 16px 42px rgba(0, 0, 0, 0.45);
}

.mine .top::after {
  display: none;
}

.mine .top .setting .service-icon {
  padding: 7px;
  border: 1px solid rgba(226, 190, 116, 0.48);
  border-radius: 50%;
  background: rgba(8, 10, 14, 0.62);
  filter: sepia(1) saturate(.65) brightness(1.25);
}

.mine .top .avatar {
  margin-top: 1rem;
}

.mine .top .avatar .van-image {
  border: 2px solid #d9b56c;
  background: rgba(12, 14, 18, 0.86);
  box-shadow: 0 0 0 5px rgba(218, 180, 105, 0.1), 0 12px 30px rgba(0, 0, 0, 0.4);
}

.mine .top .avatar .me .user p {
  color: #f4ead8;
  font-size: 1.08rem;
  font-weight: 650;
}

.mine .top .avatar .me .ps>span {
  color: #cfc2ae;
}

.mine .top .avatar .me .ps .vip-level-badge {
  display: inline-flex;
  align-items: center;
  width: auto;
  margin-top: 7px;
  padding: 5px 16px;
  border: 1px solid rgba(239, 207, 126, 0.7);
  border-radius: 999px;
  color: #f3d27f;
  background: linear-gradient(90deg, rgba(151, 105, 38, 0.28), rgba(238, 204, 122, 0.12));
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
}

.mine .top .avatar .me .progress-container {
  height: 5px;
  background: rgba(255, 255, 255, 0.14);
}

.mine .top .avatar .me .progress-bar {
  background: linear-gradient(90deg, #a97732, #efd38c);
  box-shadow: 0 0 9px rgba(231, 197, 124, 0.45);
}

.mine .center {
  width: calc(100% - 24px);
  margin-top: -3.25rem;
}

.mine .center .integral,
.mine .center .list {
  border: 1px solid rgba(218, 180, 105, 0.34);
  background: linear-gradient(145deg, rgba(15, 18, 23, 0.95), rgba(6, 8, 12, 0.97));
  box-shadow: 0 16px 38px rgba(0, 0, 0, 0.42), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(12px);
}

.mine .center .integral {
  padding: 1.15rem 0;
  border-radius: 18px;
}

.mine .center .integral:before {
  background: rgba(218, 180, 105, 0.25);
}

.mine .center .integral>div span {
  color: #e7c77f;
  font-size: .9rem;
}

.mine .center .integral>div i,
.mine .center .integral>div img,
.mine .center .list>div i img {
  filter: sepia(1) saturate(.7) hue-rotate(350deg) brightness(1.2);
}

.mine .center .mineJf {
  padding: 1.25rem 0;
  border: 1px solid rgba(229, 194, 123, 0.48);
  border-radius: 18px;
  background:
    radial-gradient(circle at 90% 15%, rgba(236, 205, 135, 0.17), transparent 38%),
    linear-gradient(135deg, rgba(35, 25, 12, 0.97), rgba(9, 11, 15, 0.97));
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.42);
}

.mine .center .mineJf .title p {
  color: #e8ca85;
}

.mine .center .mineJf .reload h1 {
  color: #f1d28a;
  text-shadow: 0 0 15px rgba(226, 183, 96, 0.2);
}

.mine .center .mineJf .reload>div {
  color: #ddd0bc;
}

.mine .center .mineJf .reload>div i {
  color: #e8ca85;
  border: 1px solid rgba(218, 180, 105, 0.3);
  background: rgba(218, 180, 105, 0.08);
}

.mine .center .list {
  padding: 1rem .25rem;
  border-radius: 20px;
}

.mine .center .list>div {
  padding: .9rem 0;
}

.mine .center .list>div:hover {
  background: rgba(218, 180, 105, 0.08);
}

.mine .center .list>div span {
  color: #d9c9ae;
  font-size: .82rem;
}

.mine .center .btns {
  padding: .9rem 0;
  color: #171006;
  font-size: .94rem;
  font-weight: 750;
  border: 1px solid rgba(247, 220, 160, 0.66);
  border-radius: 16px;
  background: linear-gradient(110deg, #a97732, #e7c87c, #bb853c);
  box-shadow: 0 10px 26px rgba(185, 130, 48, 0.28);
}

.mine .center .btns:hover {
  box-shadow: 0 13px 30px rgba(185, 130, 48, 0.38);
}

/* Account dashboard: prevent profile, balance and translated menu labels colliding. */
@media (max-width: 430px) {
  .mine,
  .page-content {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }

  .page-content {
    padding-bottom: calc(76px + env(safe-area-inset-bottom));
  }

  .mine .top {
    min-height: 224px;
    height: auto;
    padding-bottom: 62px;
  }

  .mine .top .setting {
    padding-top: max(8px, env(safe-area-inset-top));
  }

  .mine .top .avatar {
    gap: 14px;
    padding: 0 18px;
  }

  .mine .top .avatar .me,
  .mine .top .avatar .me .user,
  .mine .top .avatar .me .ps,
  .mine .top .avatar .me .ps > span {
    min-width: 0;
    max-width: 100%;
  }

  .mine .top .avatar .me {
    padding-left: 0;
  }

  .mine .top .avatar .me .user {
    flex-wrap: wrap;
    gap: 5px 7px;
  }

  .mine .top .avatar .me .user p {
    max-width: 100%;
    overflow: hidden;
    line-height: 1.35;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mine .top .avatar .me .user span {
    margin-left: 0 !important;
  }

  .mine .top .avatar .me .user img {
    width: 68px !important;
    max-width: 22vw;
    height: auto;
  }

  .mine .top .avatar .me .ps > span {
    padding-left: 0;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .mine .top .avatar .me .ps .vip-level-badge {
    padding: 5px 11px;
    font-size: 12px;
    line-height: 1.25;
    white-space: normal;
  }

  .mine .center {
    width: calc(100% - 20px);
  }

  .mine .center .integral > div,
  .mine .center .integral > div span,
  .mine .center .list > div,
  .mine .center .list > div span {
    min-width: 0;
  }

  .mine .center .integral > div {
    gap: 7px;
    padding: 8px 5px;
  }

  .mine .center .integral > div span {
    margin-left: 0;
    line-height: 1.3;
    overflow-wrap: anywhere;
  }

  .mine .center .mineJf .reload {
    gap: 12px;
  }

  .mine .center .mineJf .reload h1 {
    min-width: 0;
    max-width: 70%;
    overflow-wrap: anywhere;
    font-size: clamp(22px, 7vw, 30px);
    line-height: 1.15;
  }

  .mine .center .mineJf .reload > div {
    flex: 0 0 auto;
  }

  .mine .center .list > div {
    min-height: 96px;
    padding: 12px 4px;
  }

  .mine .center .list > div span {
    max-width: 100%;
    padding: 7px 4px 0;
    font-size: 12px;
    line-height: 1.3;
    overflow-wrap: anywhere;
    white-space: normal;
  }
}

@media (max-width: 360px) {
  .mine .top .avatar {
    padding-right: 14px;
    padding-left: 14px;
  }

  .mine .center .integral > div {
    flex-direction: column;
  }

  .mine .center .list > div {
    width: 50%;
  }
}
</style>
